import * as React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import * as styles from './announcement.module.scss';

interface Props {
  message: string;
}

/**
 * @function PriorityTwoSuccess - Component for success messages
 */
const PriorityTwoSuccess = ({ message }: Props) => {
  return (
    <div className={styles.priorityTwoSuccess}>
      <CheckCircleIcon />
      <span>{message}</span>
    </div>
  );
};

export default PriorityTwoSuccess;
